import { Material } from '../../../../sp-types';
import { INetExposure } from '../../../../sp-types/netExposureType';
import { getNetExposure } from '../../../../utils/exposureUtils';
import { convertDateToMonthYear, isEqualMonthYear, MonthYear } from '../../../../utils/MonthYear/monthYear';
import { MonthYearValue } from '../../../../utils/MonthYear/MonthYearValue';

export const getAdjustedMaterialsExposure = (
  totalExposure: { formulaId: string; exposureCalendar: MonthYearValue[] }[],
  exposureData: INetExposure,
  materialsMap: Record<string, Material>,
  convertionMap: Record<string, number>,
  currentDate?: Date,
): Record<string, number> => {
  const date: MonthYear = convertDateToMonthYear(currentDate || new Date());

  return totalExposure.reduce((acc, item) => {
    acc[item.formulaId] =
      getNetExposure(exposureData, convertionMap, item.formulaId) -
      (item.exposureCalendar.find((item) => isEqualMonthYear(item.date, date))?.value || 0) *
        materialsMap[item.formulaId].currentPrice *
        convertionMap[item.formulaId];
    return acc;
  }, {} as Record<string, number>);
};
